import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { Box } from "@material-ui/core";
import moment from "moment";

import AllItems from "../components/Views/AllItems.jsx";
import EditForm from "../components/Views/EditForm.jsx";
import AddForm from "../components/Views/AddForm.jsx";
import Container from "./Container.jsx";
import ViewForm from "../components/Views/ViewForm.jsx";
import axios from "axios";

import {
    VALUE_TYPES,
    rateChangeOperations,
    STATE_DATE_FORMAT,
    DEFAULT_GET_PARAMS_RATES_AND_SERVICES,
} from "../lib/data";
import clientConfig from "../config/client";

const fieldsNotToShow = [
    "inheritance_value",
    "inheritance_operation",
    "inheritance_unit",
    "base_rate_id",
    "inheritance_stops",
    "additional",
    "non_returnable",
    "external_id",
];

const { locale } = clientConfig;

const LABELS = {
    inherit: {
        error: {
            ru: "Ошибка наследования тарифа",
            en: "Error during rate inheritance",
        },
        success: {
            ru: "Тариф наследован успешно",
            en: "Rate inherited successfully",
        },
        notSelectedBase: {
            ru: "Не выбран базовый тариф",
            en: "Base rate not selected",
        },
    },
};

class RatesContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("rates");
        this.getAuxData();
        this.state = {
            ...this.state,
            basisRateValues: [],
            rateIsInheriting: false,
            unusedServicesHidden: true,
            getParams: { ...DEFAULT_GET_PARAMS_RATES_AND_SERVICES },
        };
    }

    toggleUnusedServicesHandler = () => {
        this.setState((prevState) => ({
            unusedServicesHidden: !prevState.unusedServicesHidden,
        }));
    };

    getBaseRateVals = async (selRateId) => {
        if (this.state.AllItems?.length <= 0) throw new Error();
        const path = this.datasource.dataPath + "/room_rate_prices";

        const startDate = moment(
            this.state.currentItem.date_start,
            STATE_DATE_FORMAT,
        ).isBefore(moment())
            ? moment().format(STATE_DATE_FORMAT)
            : this.state.currentItem.date_start;

        const response = await axios.get(path, {
            params: {
                date_start: startDate,
                date_end: this.state.currentItem.date_end,
                rate: selRateId,
            },
        });

        return response.data;
    };

    updateCurRateFromBase = async () => {
        if (!this.state.currentItem) return;
        const baseRateId = this.state.currentItem.base_rate_id;
        // if base rate not selected  - fallback
        if (!baseRateId) {
            alert(LABELS.inherit.notSelectedBase[locale]);
            return;
        }

        const curRateId = this.state.currentItem.id;
        const path =
            this.datasource.dataPath +
            "/" +
            this.datasource.modelName +
            "/" +
            curRateId +
            "/inherit";

        const operation =
            this.state.currentItem.inheritance_unit ===
            VALUE_TYPES.percent.value
                ? rateChangeOperations.multiply.value
                : this.state.currentItem.inheritance_operation;
        let value = +this.state.currentItem.inheritance_value;

        if (
            this.state.currentItem.inheritance_unit ===
            VALUE_TYPES.percent.value
        ) {
            if (
                this.state.currentItem.inheritance_operation ===
                rateChangeOperations.subtract.value
            ) {
                value = (1 - value / 100).toFixed(2);
            } else {
                value = (1 + value / 100).toFixed(2);
            }
        }

        try {
            this.setState({ rateIsInheriting: true });
            const inheritResponse = await axios.post(path, {
                base_rate_id: baseRateId,
                operation,
                value,
                inheritance_stops: +this.state.currentItem.inheritance_stops,
            });

            inheritResponse.data.success &&
                alert(LABELS.inherit.success[locale]);
            this.updateItem();
        } catch (err) {
            alert(LABELS.inherit.error[locale]);
        } finally {
            this.setState({ rateIsInheriting: false });
        }
    };

    copyRate = (id) =>
        axios
            .get("/manager/data/hotels/copy_rate/" + id)
            .then((response) => {
                alert(response?.data);
                this.getAllItems();
            })
            .catch((error) => alert(error));

    getItemsToInherit = () =>
        this.state.AllItems.filter(
            (item) =>
                item.active &&
                item.id !== this.state.currentItem?.id &&
                !item.inherited &&
                moment(item.date_end, "YYYY-MM-DD").isAfter(moment()),
        );

    updateRate = () => {
        const data = this.updateForRate();

        if (!data) return;

        return this.setLoading(() =>
            this.datasource
                .updateOne(data)
                .then(() => {
                    this.props.history.push(this.datasource.routes().home);
                })
                .catch((result) => this.handleUpdateError(result.response)),
        );
    };

    updateRateWithoutReload = () => {
        const data = this.updateForRate();

        if (!data) return;

        return this.datasource
            .updateOne(data)
            .then(() => alert("Успешно сохранено"))
            .catch((result) => this.handleUpdateError(result.response));
    };

    updateForRate = () => {
        const itemToSend = {
            ...this.state.currentItem,
            base_rate_id: !this.state.currentItem.inherited
                ? null
                : this.state.currentItem.base_rate_id,
        };

        if (!itemToSend.description && !itemToSend?.base_rate_for_bar) {
            alert("ОПИСАНИЕ обязательно к заполнению, заполните это поле");
            return;
        }

        if (itemToSend.multiple_days > 1 && itemToSend.min_stay > 1)
            alert(
                "Настройки минимально ночей работать в этом тарифе не будет, так как установлено значение кратно дням!",
            );

        return itemToSend;
    };

    getBackLink = () => this.datasource.routes().home;

    getAll = (params = {}) => {
        const path = this.datasource.dataPath + "/" + this.modelName;

        return axios.get(path, { params }).then((response) => response.data);
    };

    getAllItems = (params) =>
        this.getAll(params)
            .then((resData) => {
                this.setState({
                    AllItems: resData,
                    loading: false,
                });
            })
            .catch((error) => {
                this.handleSearchError(error.response);
            });

    paramsChangeHandler = (newParams) => this.getAllItems(newParams);

    render = () => {
        const notPermitted = this.checkAvailability();

        if (notPermitted) {
            return <Route render={() => <Redirect to="/" replace />} />;
        }

        if (this.state.rateIsInheriting) {
            return <Box>Тариф наследуется...</Box>;
        }

        const editFields = this.datasource.getSchemaFields();
        if (!this.state.currentItem?.inherited) {
            Reflect.deleteProperty(editFields, "inheritance");
            Reflect.deleteProperty(editFields, "base_rate");
        }
        if (this.state.currentItem?.inherited) {
            Reflect.deleteProperty(editFields, "dependent_rates");
            // Reflect.deleteProperty(editFields, "additional");
        }
        const formattedEditFields = formatFields(editFields, fieldsNotToShow);

        const fields = { ...editFields };
        Reflect.deleteProperty(fields, "inheritance");

        const formattedFields = formatFields(fields, fieldsNotToShow);
        const itemsToInherit = this.getItemsToInherit();

        const routes = this.datasource.routes();
        const relations = this.datasource.getSchemaRelations();
        const relationsDataSource = this.datasource.relations;

        return (
            <Switch>
                <Route path={routes.home} exact>
                    <AllItems
                        title="Список тарифов"
                        columns={{
                            id: "Id",
                            name: "Наименование",
                            active: "Активен",
                            date_residence: "Даты проживания",
                            date_booking: "Даты бронирования",
                            order: "Порядок",
                        }}
                        addRoute={routes.add}
                        initAction={this.getAllItems}
                        items={this.state.AllItems}
                        loading={this.state.loading}
                        viewAction={this.getViewLink}
                        copyObject={this.copyRate}
                        editAction={this.getEditLink}
                        toggleAction={this.toggleItem}
                        removeAction={this.removeItem}
                        getParams={this.state.getParams}
                        paramsChangeHandler={this.paramsChangeHandler}
                        needViewCopyButton={true}
                        updateParticularItem={this.updateParticularItem}
                        defaultSortfield={"order"}
                        globalSearch={this.globalSearch}
                        updateGlobalSearch={this.updateGlobalSearch}
                        partition="rate"
                    />
                </Route>
                <Route path={routes.add()} exact>
                    <AddForm
                        title={"Новый тариф"}
                        loading={this.state.loading}
                        fields={formattedFields}
                        initAction={this.initCurrentItem}
                        item={this.state.currentItem}
                        getBackLink={this.getBackLink}
                        submitAction={this.addItem}
                        fieldUpdateHandler={this.setFieldValue}
                        errorFields={this.state.error}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        setRelationsValue={this.setRelationsValue}
                        defaultPaymentTypes={
                            this.props.auxData?.payment_methods
                        }
                        defaultServices={this.props.auxData?.services}
                        defaultRates={this.props.auxData?.rates}
                        serviceCategories={
                            this.props.auxData?.service_categories
                        }
                        unusedServicesHidden={{
                            unusedServicesHidden:
                                this.state.unusedServicesHidden,
                            toggleUnusedServicesHandler:
                                this.toggleUnusedServicesHandler,
                        }}
                        defaultRoomTypes={this.props.auxData?.room_types}
                        interfaceTypes={this.props?.auxData?.market_codes || []}
                        cancellationPolicy={this.props?.auxData?.cancellation_policy || []}
                    />
                </Route>
                <Route path={routes.view(":id")} exact>
                    <ViewForm
                        title="Просмотр тарифа"
                        loading={this.state.loading}
                        fields={formattedFields}
                        initAction={this.getItem}
                        item={this.state.currentItem}
                        getBackLink={this.getBackLink}
                        getHotelUsersLink={this.getHotelUsersLink}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        defaultPaymentTypes={
                            this.props.auxData?.payment_methods
                        }
                        defaultServices={this.props.auxData?.services}
                        defaultRates={this.props.auxData?.rates}
                        serviceCategories={
                            this.props.auxData?.service_categories
                        }
                        unusedServicesHidden={{
                            unusedServicesHidden:
                                this.state.unusedServicesHidden,
                            toggleUnusedServicesHandler:
                                this.toggleUnusedServicesHandler,
                        }}
                    />
                </Route>
                <Route path={routes.edit(":id")} exact>
                    <EditForm
                        loading={this.state.loading}
                        item={this.state.currentItem}
                        fields={formattedEditFields}
                        errorFields={this.state.error}
                        initAction={this.getItem}
                        submitAction={this.updateRate}
                        submitActionApply={this.updateRateWithoutReload}
                        addPeriodPrice={this.addPeriodPrice}
                        getBackLink={this.getBackLink}
                        fieldUpdateHandler={this.setFieldValue}
                        relationsDataSource={relationsDataSource}
                        defaultPaymentTypes={
                            this.props.auxData?.payment_methods
                        }
                        defaultServices={this.props.auxData?.services}
                        defaultRates={this.props.auxData?.rates}
                        serviceCategories={
                            this.props.auxData?.service_categories
                        }
                        updateCurRateFromBase={this.updateCurRateFromBase}
                        allItems={itemsToInherit}
                        inheritStarted={this.state.currentItem?.inheritStarted}
                        unusedServicesHidden={{
                            unusedServicesHidden:
                                this.state.unusedServicesHidden,
                            toggleUnusedServicesHandler:
                                this.toggleUnusedServicesHandler,
                        }}
                        defaultRoomTypes={this.props.auxData?.room_types}
                        thisRates={true}
                        interfaceTypes={this.props?.auxData?.market_codes || []}
                        cancellationPolicy={this.props?.auxData?.cancellation_policy || []}
                        hotelId={this.props.hotelId}
                    />
                </Route>
            </Switch>
        );
    };
}

// helper funcs

const formatFields = (fields, fieldsToRemoveNamesArr) => {
    const updatedFields = { ...fields };

    for (let fieldName of fieldsToRemoveNamesArr) {
        Reflect.deleteProperty(updatedFields, fieldName);
    }

    return updatedFields;
};

export default RatesContainer;
